import {Column} from '@ozark/common/api/Column';
import {ReferralOverrideResidual} from '@ozark/functions/src/functions/express/private/types/Residual';
import startcase from 'lodash/startCase';
import {currentFormatter} from '../../reports';
import {formatYearMonth, getFormattedDate} from './helpers';

export const getColumns = (): Column<ReferralOverrideResidual>[] => {
  return [
    {
      id: 'yearMonth',
      numeric: false,
      sortable: true,
      export: true,
      label: 'Date',
      selector: (row: ReferralOverrideResidual) => {
        return formatYearMonth(row.yearMonth);
      },
    },
    {
      id: 'mid',
      numeric: false,
      sortable: true,
      label: 'Merchant ID',
      horizontallySticky: true,
      width: 150,
    },
    {
      id: 'agentName',
      numeric: false,
      sortable: true,
      label: 'Agent Name',
      horizontallySticky: true,
      width: 150,
    },
    {
      id: 'dba',
      numeric: false,
      sortable: true,
      label: 'DBA',
      horizontallySticky: true,
    },
    {
      id: 'accountStatus',
      numeric: false,
      sortable: true,
      label: 'Account Status',
    },
    {
      id: 'boardedAt',
      numeric: false,
      sortable: true,
      label: 'Boarded Date',
      export: (row: ReferralOverrideResidual) => getFormattedDate(row.boardedAt),
      selector: (row: ReferralOverrideResidual) => getFormattedDate(row.boardedAt),
    },
    {
      id: 'legalBusinessName',
      numeric: false,
      sortable: true,
      label: 'Legal Name',
    },
    {
      id: 'riskLevel',
      numeric: false,
      sortable: true,
      label: 'Risk Level',
      selector: (row: ReferralOverrideResidual) => startcase(row.riskLevel),
    },
    {
      id: 'transactionCount',
      numeric: true,
      sortable: true,
      label: 'Bankcard Transaction Count (Visa/MC/Disc)',
    },
    {
      id: 'transactionCountAmex',
      numeric: true,
      sortable: true,
      label: 'Bankcard Transaction Count (Amex)',
    },
    {
      id: 'bankcardSalesVolume',
      numeric: true,
      sortable: true,
      label: 'Bankcard Sales Volume (Visa/MC/Disc)',
      selector: (row: ReferralOverrideResidual) => currentFormatter.format(row.bankcardSalesVolume),
    },
    {
      id: 'bankcardSalesVolumeAmex',
      numeric: true,
      sortable: true,
      label: 'Bankcard Sales Volume (Amex)',
      selector: (row: ReferralOverrideResidual) =>
        currentFormatter.format(row.bankcardSalesVolumeAmex),
    },
    {
      id: 'averageTicket',
      numeric: true,
      sortable: true,
      label: 'Bankcard Average Ticket',
      selector: (row: ReferralOverrideResidual) => {
        return row.averageTicket ? currentFormatter.format(+row.averageTicket) : 'N/A';
      },
    },
    {
      id: 'pinDebitCount',
      numeric: false,
      sortable: true,
      label: 'EBT/PIN Debit Transaction Count',
      selector: (row: ReferralOverrideResidual) => row.pinDebitCount ?? '',
    },
    {
      id: 'pinDebitSalesVolume',
      numeric: false,
      sortable: true,
      label: 'EBT/PIN Debit Sales Volume',
      selector: (row: ReferralOverrideResidual) =>
        row.pinDebitSalesVolume ? currentFormatter.format(row.pinDebitSalesVolume) : '',
    },
    {
      id: 'equipmentAgentExpense',
      numeric: true,
      sortable: true,
      label: 'Equipment Expense',
      selector: (row: ReferralOverrideResidual) =>
        row.equipmentAgentExpense ? currentFormatter.format(row.equipmentAgentExpense) : '',
    },
    {
      id: 'overrideSplitPercent',
      numeric: true,
      sortable: false,
      label: 'Override Split',
      selector: (row: ReferralOverrideResidual) =>
        row.overrideSplitPercent ? `${row.overrideSplitPercent}%` : '',
    },
    {
      id: 'overrideNetSplit',
      numeric: true,
      sortable: false,
      label: 'Override Amount',
      selector: (row: ReferralOverrideResidual) =>
        row.overrideNetSplit ? currentFormatter.format(row.overrideNetSplit) : '',
    },
  ];
};
